import { useCallback, useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import { Layout } from '~/components';
import { usePowerCreator } from '~/hooks/powerCreator';
import api from '~/services/api';

import Basic from './Basic';
import CreatePlan from './CreatePlan';
import { IProgram } from './interface';
import MasterClass from './MasterClass';
import Premium from './Premium';

export default function TurboTraining() {
  const {
    location: { state },
  } = useHistory();
  const { updatePowerCreators } = usePowerCreator();
  const [program, setProgram] = useState<IProgram | null>(null);
  const [training_program, set_training_program] = useState<IProgram>(
    state as IProgram,
  );
  const { billing_id, student_id, program_id } = training_program;

  const handleUpdateProgram = useCallback(async () => {
    const { data } = await api.get(
      `/training-programs/${program_id}/divisions`,
    );

    setProgram(data.header);
  }, [program_id]);

  useEffect(() => {
    handleUpdateProgram();
  }, [handleUpdateProgram]);

  useEffect(() => {
    if (program?.data_model) {
      set_training_program(program as IProgram);
    }
  }, [program]);

  useEffect(() => {
    updatePowerCreators();
  }, [updatePowerCreators]);

  const screenComponent: { [key: string]: JSX.Element } = {
    null: (
      <CreatePlan
        billingId={billing_id}
        studentId={student_id}
        programId={program_id}
        refreshProgram={handleUpdateProgram}
      />
    ),
    Basic: <Basic refreshProgram={handleUpdateProgram} />,
    Premium: <Premium refreshProgram={handleUpdateProgram} />,
    MasterClass: <MasterClass refreshProgram={handleUpdateProgram} />,
  };

  return (
    <Layout title="Aluno">
      {screenComponent[training_program?.data_model]}
    </Layout>
  );
}
